import { IExperimentResultSchema } from '../../repositories/ab-use/entities/entities/ExperimentResultSchema';

export function checkNewExperiment(
  experiments: IExperimentResultSchema[],
  experimentName: string,
  groupName: string,
): boolean {
  const resultExperiment = experiments.find(f => f.experimentName === experimentName);

  if (resultExperiment && resultExperiment.groupName) {
    return resultExperiment.groupName === groupName;
  }

  return false;
}
